
import Vue from 'vue';
import {TherapyUnit} from "@/models/schedulerEvent";
import ActivityService from "../services/activity.service";
import {eventBus} from "@/services/event-bus";
import Patient, {WritePatient, WriteTherapyUnit} from "../models/patient";
import SchedulerService from "../services/scheduler.service";
import Activity from "@/models/activity";
import Party from "@/models/party";

export default Vue.extend({
  data() {
    return {
      weeklyNumbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      editingIndex: -1,
      activities: [] as Activity[],
      therapists: [] as Party[],
      durations: [
        '30',
        '45',
        '60',
        '90',
        '120',
        '150',
        '180',
        '210',
      ],
    }
  },
  props: ['patient', 'period'],
  methods: {
    addTherapy(item: any) {
      if (item.therapyUnits == null || item.therapyUnits[item.therapyUnits.length - 1] == null || item.therapyUnits[item.therapyUnits.length - 1].id != null) {
        const idx = item.therapyUnits?.push(new TherapyUnit({})) - 1;
        this.toggle(idx);
      }
    },
    deleteTherapy(item: any) {
      if (this.patient !== null) {
        const patient = this.patient as any;
        const idx = patient.therapyUnits.findIndex((el: any) => el === item);
        if (idx > -1) {
          patient.therapyUnits.splice(idx, 1);
        }
      }
      this.savePatient(new Patient(this.patient));

    },
    toggle(index: number) {
      this.editingIndex = (this.editingIndex === index) ? -1 : index
    },
    loadActivities() {
      return ActivityService.activities().then(d => this.activities = d).catch(reason => eventBus.$emit('error', reason))
    },
    savePatient(p: Patient) {
      return SchedulerService
          .updatePatient(new WritePatient(p.id,
              this.period.id,
              p.therapyUnits!!.map((value: TherapyUnit) => new WriteTherapyUnit({
                activity: value.activity!!.id,
                weeklyNumber: value.weeklyNumber,
                duration: value.duration,
                preferredTherapist: value.preferredTherapist
              }))))
          .then(() => this.editingIndex = this.period.patients !== undefined ? this.period.patients.findIndex((e: any) => e === p) : -1)
          .then(() => eventBus.$emit('updatePeriod'))
          .then(() => eventBus.$emit('update-activities'))
    },
    toTimeString(duration: number) {
      const t = ((Math.round(duration / 60 * 100) / 100).toFixed(2) + '').split('.')
      return t[0] + " godz. " + ((t[1] === '00') ? '' : ((Number(t[1]) * 0.6) + ' min.'));
    },
    toActivityLabel(party: Activity) {
      const availability = party.availability?.availability ?
          party.availability?.availability : 0
      const occupancyIdx = party.availability?.periodOccupancy?.findIndex(el => el.periodId === this.period.id);
      let occupancy = 0;
      if (occupancyIdx !== undefined && occupancyIdx > -1) {
        occupancy = party.availability?.periodOccupancy[occupancyIdx]?.occupancy ?
            party.availability?.periodOccupancy[occupancyIdx]?.occupancy : 0
      }
      return `${party.name} ${availability - occupancy}`
    },

  },
  created() {
    this.loadActivities();
    eventBus.$on('delete-patient', (item: Patient) => {
      this.savePatient(new Patient({id: item.id, name: item.name, surname: item.surname, therapyUnits: []}));
    });
    eventBus.$on('update-activities', () => {
      this.loadActivities();
    });

  }
});
